import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ugcCommentShape, catalogBibShape } from '@bibliocommons/bc-prop-types';
import { selectStaffCommentsForCurrentBib } from 'app/selectors/bibs/UgcSelector';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectCommentsTransactions } from 'app/selectors/ugc/CommentsSelector';
import BibsActions from 'app/actions/BibsActions';
import StaffComments from './StaffComments';

export class StaffCommentsContainer extends React.PureComponent {
  render() {
    return <StaffComments {...this.props} />;
  }
}

StaffCommentsContainer.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  comments: ImmutablePropTypes.listOf(ugcCommentShape),
  commentsTransactions: ImmutablePropTypes.map.isRequired,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = state => ({
  catalogBib: selectCatalogBib(state),
  commentsTransactions: selectCommentsTransactions(state),
  comments: selectStaffCommentsForCurrentBib(state)
});

const mapDispatchToProps = dispatch => ({
  bibsActions: bindActionCreators(BibsActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(StaffCommentsContainer);
